import React, {useContext} from "react";
import DropDown from "./Dropdown";
import LanguageToggler from "./LanguageToggler";
import provinces from "./model/provinces";
import Context from "./EventsProvider";
import styled from "@emotion/styled";

import { Sizes, Typography } from "../../styles";

const DropDownContainer = () => {
	const { data: { language, labelText },
		actions: { setParams, setSelectedDate, setLabel }, 
	} = useContext(Context);

	const handleClearFilters = () => {
		setParams((currentValue) => {
			if (currentValue.date) {
				const selectedMonth = currentValue.date.slice(3);
				return {month: selectedMonth, lang: language};
			} else {
				return {month: currentValue.month, lang: language};
			}

		});
		setSelectedDate(null);
		setLabel( labelText() );
	}

	const clearFiltersText = () => {
		if (language === "en"){
			return 'clear filters';
		}
		return 'effacer les filtres';
	}

	if (!provinces) return;

	return (
		<Container>
			<FiltersContainer>
				{
					provinces[language].map((list) => {
						return (
							<DropDown
								key={list.key}
								filterKey={list.key}
								dropDownFilters={list.filters}
								DropDownLabel={list.title}
							/>
						);
					})
				}
				<ClearFiltersButton 
					type="button"
					onClick={handleClearFilters}
					aria-label="clear date, location, and language filters"
				>
					{clearFiltersText()}
				</ClearFiltersButton>
			</FiltersContainer>
			<LanguageToggler />
		</Container>
	);
}

export default DropDownContainer;

const Container = styled.div`
	order: 2;
	max-width: 31rem;
	width: 100%;
	margin: 0 auto;

    @media only screen and (min-width: ${Sizes.screens.large}) {
		display: flex;
		align-items: center;
		gap: 2.5rem;
		max-width: unset;
        margin: 0 0 3rem;
        width: 100%;
		order: unset;
		justify-content: space-between;
    }
`;

const ClearFiltersButton = styled.button`
	all: unset;
	font-size: 1.3rem;
	line-height: 1.5rem;
	font-weight: ${Typography.fontWeight.medium};
	cursor: pointer;
	text-decoration: underline;
	place-self: start;
	width: 100%;
	margin: 2.5rem auto 0;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		margin: unset;
		width: unset;
		place-self: unset;
	}

	&:hover,
	&:focus {
		padding-right: unset;
	}
		
	&:focus-visible {
		outline: solid 2px -webkit-focus-ring-color;
	}
`;

const FiltersContainer = styled.div`
	@media only screen and (min-width: ${Sizes.screens.large}) {
		display: flex;
		flex-basis: 100%;
		justify-content: flex-start;
		column-gap: 2.5rem;
	}
`;
